import styled, { css } from 'styled-components';

export const ImgStyled = styled.img`
  ${({ variant, fullWidth }) => css`
    display: block;
    ${variant === 'round' && 'border-radius: 50%;'}
    ${fullWidth ? 'width: 100%;' : 'width: auto;'}
  `}
`;

export const PictureStyled = styled.picture`
  display: flex;
`;
